<template>
  <div>
    <title-row
      :title="page.title"
      :subtitle="page.subtitle"
      :breadcrumb-items="[
        {
          text: 'Időszakok',
          to: { name: 'DateIntervalList' },
        },
        page.breadcrumbItem,
      ]"
    >
      <template #buttons>
        <title-row-button @click="save" :disabled="loading">
          <v-icon left>mdi-check</v-icon>
          Mentés
        </title-row-button>
      </template>
    </title-row>

    <v-card :loading="loading" class="rounded-xl">
      <v-card-text>
        <v-text-field label="Megnevezés" :error-messages="errors.name" v-model="form.name" filled />
        <v-row class="m-1">
          <v-col :cols="12" :md="6">
            <v-datetime-picker
              label="Kezdő dátum"
              :error-messages="errors.start_date"
              :timePicker="false"
              datePicker
              v-model="form.start_date"
              filled
            />
          </v-col>
          <v-col :cols="12" :md="6">
            <v-datetime-picker
              label="Záró dátum"
              :error-messages="errors.end_date"
              :timePicker="false"
              datePicker
              v-model="form.end_date"
              filled
            />
          </v-col>
        </v-row>
        <v-switch
          inset
          messages="Ez az időszak minden évben ismétlődni fog a megadott kezdő és záró dátum között."
          label="Évente ismétlődő időszak"
          v-model="form.is_recurring"
        >
        </v-switch>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: '',
        start_date: '',
        end_date: '',
        is_recurring: false,
      },

      errors: [],
      loading: false,
    };
  },

  async mounted() {
    this.fetchDateInverval();
  },

  methods: {
    async fetchDateInverval() {
      try {
        const response = await this.$http.get(
          `date-intervals/details/${this.$route.params.id || 0}`
        );
        this.form = response.date_interval;
      } catch (e) {
        console.error(e);
      }
    },

    async save(event) {
      try {
        this.errors = {};
        this.loading = true;
        const response = await this.$http.post('date-intervals/save/', this.form);
        if (this.lodash.size(response.errors) > 0) {
          this.errors = response.errors;
          return;
        }

        if (response.status === 'OK') {
          this.$dialog.notify.success('Sikeres mentés');
          if (this.$route.name === 'NewDateInterval') {
            this.$router.push({
              name: 'DateIntervalEditor',
              params: { id: response.date_interval.id },
            });
          } else {
            this.fetchScheduleGroup();
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    page() {
      switch (this.$route.name) {
        case 'NewDateInterval':
          return {
            isNew: true,
            title: 'Új időszak létrehozása',
            breadcrumbItem: {
              text: 'Új időszak létrehozása',
              disabled: true,
            },
          };
        case 'DateIntervalEditor':
          return {
            isNew: false,
            title: `Időszak: ${this.form.name ?? 'Betöltés...'}`,
            //subtitle: `Tulajdonos: ${this.cardOwnerName ?? 'Betöltés...'}`,
            breadcrumbItem: {
              text: this.form.name,
              disabled: true,
            },
          };
      }
      return {};
    },
  },
};
</script>
